import { RouteRecordRaw } from 'vue-router';

const rotasAplicacao: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'Aplicacao',
    component: () => import(/* webpackChunkName: "core" */ '@/core/layout/SubLayout.vue'),
    children: [
      {
        path: 'sem-privilegio',
        name: 'SemPrivilegio',
        meta: {
          titulo: 'Você não possui autorização!',
          identificadorPermissao: '',
        },
        component: () => import(/* webpackChunkName: "core" */ '@/core/views/SemPrivilegio.vue'),
      },
      {
        path: '',
        redirect: '/inspecoes',
      },
      {
        path: 'configuracoes',
        name: 'Configuracoes',
        meta: {
          titulo: 'Configurações',
          identificadorPermissao: 'CONFIGURACOES',
        },
        component: () => import(/* webpackChunkName: "configuracoes" */ '@/views/Configuracoes.vue'),
      },
      {
        path: 'configuracoes-emails',
        name: 'ConfiguracoesEmails',
        meta: {
          titulo: 'Configurações de E-mails',
          identificadorPermissao: 'CONFIGURACOES',
        },
        component: () => import(/* webpackChunkName: "configuracoes" */ '@/views/ConfiguracoesEmails.vue'),
      },
      {
        path: 'meu-negocio',
        name: 'MeuNegocio',
        meta: {
          titulo: 'Meu Negócio',
          identificadorPermissao: 'MEU_NEGOCIO',
        },
        component: () => import(/* webpackChunkName: "configuracoes" */ '@/views/MeuNegocio.vue'),
      },
      {
        path: 'usuarios',
        name: 'Usuarios',
        meta: {
          titulo: 'Usuários',
          identificadorPermissao: 'USUARIOS',
        },
        component: () => import(/* webpackChunkName: "usuarios" */ '@/views/Usuarios/UsuarioListagem.vue'),
      },
      {
        path: 'usuarios/cadastrar',
        name: 'UsuarioCadastroCriar',
        meta: {
          titulo: 'Cadastrar Usuário',
          identificadorPermissao: 'USUARIOS',
        },
        component: () => import(/* webpackChunkName: "usuarios" */ '@/views/Usuarios/UsuarioCadastro.vue'),
      },
      {
        path: 'usuarios/:codigo',
        name: 'UsuarioCadastroEditar',
        meta: {
          titulo: 'Editar Usuário',
          identificadorPermissao: 'USUARIOS',
        },
        component: () => import(/* webpackChunkName: "categorias" */ '@/views/Usuarios/UsuarioCadastro.vue'),
      },
      {
        path: 'usuarios/meus-dados',
        name: 'UsuarioMeusDados',
        meta: {
          titulo: 'Meus Dados',
          identificadorPermissao: '',
        },
        component: () => import(/* webpackChunkName: "usuarios" */ '@/views/Usuarios/MeusDados.vue'),
      },
      {
        path: 'segurados',
        name: 'Segurados',
        meta: {
          titulo: 'Segurados',
          identificadorPermissao: 'CADASTROS',
        },
        component: () => import(/* webpackChunkName: "segurados" */ '@/views/Segurados/SeguradoListagem.vue'),
      },
      {
        path: 'segurados/cadastrar',
        name: 'SeguradoCadastroCriar',
        meta: {
          titulo: 'Cadastrar Segurado',
          identificadorPermissao: 'CADASTROS',
        },
        component: () => import(/* webpackChunkName: "segurados" */ '@/views/Segurados/SeguradoCadastro.vue'),
      },
      {
        path: 'segurados/:codigo',
        name: 'SeguradoCadastroEditar',
        meta: {
          titulo: 'Editar Segurado',
          identificadorPermissao: 'CADASTROS',
        },
        component: () => import(/* webpackChunkName: "segurados" */ '@/views/Segurados/SeguradoCadastro.vue'),
      },
      {
        path: 'inspecoes',
        name: 'Inspecoes',
        meta: {
          titulo: 'Inspeções',
          identificadorPermissao: 'INSPECOES',
        },
        component: () => import(/* webpackChunkName: "inspecoes" */ '@/views/Inspecoes/InspecaoListagem.vue'),
      },
      {
        path: 'inspecoes/nova',
        name: 'InspecaoCadastroCriar',
        meta: {
          titulo: 'Registro de Inspeção',
          identificadorPermissao: 'INSPECOES',
        },
        component: () => import(/* webpackChunkName: "inspecoes" */ '@/views/Inspecoes/InspecaoCadastro.vue'),
      },
      {
        path: 'inspecoes/:codigo',
        name: 'InspecaoCadastroEditar',
        meta: {
          titulo: 'Editar Inspeção',
          identificadorPermissao: 'INSPECOES',
        },
        component: () => import(/* webpackChunkName: "inspecoes" */ '@/views/Inspecoes/InspecaoCadastro.vue'),
      },
      {
        path: 'inspecoes/:codigo/valores',
        name: 'InspecaoValoresCadastro',
        meta: {
          titulo: 'Valores da Inspeção',
          identificadorPermissao: 'INSPECOES',
        },
        component: () => import(/* webpackChunkName: "inspecoes" */ '@/views/Inspecoes/InspecaoValoresCadastro.vue'),
      },
    ],
  },
];

export default rotasAplicacao;
